import * as React from 'react';

import { cn } from '@/components/atoms/primitives/utils';

/**
 * WEB-1001 — the design-system count (DS 1.9.0 `.a-count`): a 20 high
 * tabular-figure pill for unread / quantity. `quiet` for counts that are not
 * asking for attention.
 */
export interface CountProps extends React.HTMLAttributes<HTMLSpanElement> {
  quiet?: boolean;
}

export function Count({ quiet = false, className, ...props }: CountProps): React.ReactElement {
  return <span className={cn('a-count', quiet && 'a-count--quiet', className)} {...props} />;
}
